import {Component, OnInit} from '@angular/core';

@Component({
    selector: '[app-question-damage-image-front]',
    templateUrl: './question-damage-image-front.component.html',
    styleUrls: ['./question-damage-image-front.component.scss'],
    standalone: false
})
export class QuestionDamageImageFrontComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
